'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Il servizio non è attualmente disponibile. Riprova più tardi.',
    NEED_ACTIVE: "Il tuo account {{account}} sta usando questo sito web per la prima volta. Per favore {{activeLink}} per completare l'attivazione e torna su questa pagina per continuare le operazioni",
    GOTO_ACTIVE: 'Attiva ora',
    NOT_ACTIVED: "L'account non è stato attivato con successo, per favore {{activeLink}} per completare l'attivazione",
    COMPLETE_ACTIVE: "Conferma l'attivazione",
    FORBID_ACTIVE: 'Questo account non è supportato su AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Accedi con un altro account',
    ACTIVE_PAGE: "Visita la pagina di attivazione dell'account"
};